export class Theme {

  defaultBackgroundUrl = '';
  urlBackgroundMap = new Map<string, string>();

  initialize(data: any) {
    this.clear();
    this.reloadData(data);
  }

  reloadData(data: any) {
    if (!data || !(data instanceof Array)) {
      return;
    }

    for (const item of data) {
      if (!item) {
        continue;
      }

      const filePath = item.file_path;
      const shopRouts = item.shop_routs;
      if (!filePath || !shopRouts || !(shopRouts instanceof Array)) {
        continue;
      }

      for (const shopRout of shopRouts) {
        if (!shopRout) {
          continue;
        }

        if (shopRout === '*') {
          this.defaultBackgroundUrl = filePath;
          continue;
        }

        this.urlBackgroundMap.set(shopRout, filePath);
      }
    }
  }

  getBackgroundAssetUrl(routeUrl: string): string {
    return this.urlBackgroundMap.get(routeUrl) || this.defaultBackgroundUrl;
  }

  private clear() {
    this.defaultBackgroundUrl = '';
    this.urlBackgroundMap.clear();
  }
}
